export class VideoPlayer {
    private readonly container: HTMLElement;
    private readonly video: HTMLVideoElement;
    private readonly button: HTMLButtonElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.video = VideoPlayer.findVideo(container);
        this.button = VideoPlayer.findButton(container);

        this.play = this.play.bind(this);
        this.reset = this.reset.bind(this);
        this.hideOverlays = this.hideOverlays.bind(this);
        this.showOverlays = this.showOverlays.bind(this);

        this.video.addEventListener('play', this.hideOverlays);
        this.video.addEventListener('pause', this.showOverlays);
        this.video.addEventListener('ended', this.reset);
        this.button.addEventListener('click', this.play);
    }

    play() {
        this.video.play();
        this.video.controls = true;
    }

    reset() {
        this.video.currentTime = 0;
    }

    hideOverlays() {
        this.overlays.forEach(overlay => {
            overlay.hidden = true;
        });
    }

    showOverlays() {
        this.overlays.forEach(overlay => {
            overlay.hidden = false;
        });
    }

    get overlays() {
        return this.container.querySelectorAll<HTMLElement>('[data-hide-on-play]');
    }

    static findVideo(container: HTMLElement): HTMLVideoElement {
        const video = container.querySelector('video');

        if (video === null) {
            throw new Error('The VideoPlayer component requires a video element.');
        }

        return video;
    }

    static findButton(container: HTMLElement): HTMLButtonElement {
        const button = container.querySelector('button');

        if (button === null) {
            throw new Error('The VideoPlayer component requires a button element.');
        }

        return button;
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            return new VideoPlayer(container);
        });
    }
}
